import DashboardGridBase from "./shared/dashboard_grid_base"

// Group-management dashboard grid: shares the edit-mode engine with the tenant grid (see
// shared/dashboard_grid_base). Uses viewport breakpoints and persists resizes per widget via
// the URL on each cell (data-widget-resize-url), which replies with a turbo-stream grid
// replace; heights go to the cell's data-widget-height-url the same way.
export default class extends DashboardGridBase {
  get colSpanClasses() {
    return {
      1: ["col-span-4", "md:col-span-1"],
      2: ["col-span-4", "md:col-span-2"],
      3: ["col-span-4", "md:col-span-3"],
      4: ["col-span-4"],
    }
  }

  get colSpanRemovalList() {
    return ["md:col-span-1", "md:col-span-2", "md:col-span-3", "md:col-span-4", "col-span-4"]
  }

  resizeRequest(container, _widgetId, newWidth) {
    return { url: container.dataset.widgetResizeUrl, body: { width: newWidth } }
  }

  heightRequest(container, _widgetId, height) {
    return { url: container.dataset.widgetHeightUrl, body: { height } }
  }
}
